import request from '@/utils/request';


export function login(email: string, password: string, language: string) {
  return request.post('/admin/auth/signIN',
    {
      email,
      password,
      language,
    });
}


export function logout() {
  return request.post('/admin/auth/logout');
}
